import { GenericResponse } from 'services/api/base';
import {
  GetInstructionTabsResponse,
  InstructionTab,
} from 'types/Flux/About/getInstructionTabsResponse';

export const transformInstructionTabsResponse = (response: GetInstructionTabsResponse) => (
  Object.keys(response.data).map((key) => ({
    id: Number(key),
    title: response.data[key],
  }))
);

export const transformInstructionPdfResponse = (response: GenericResponse<string>) => (
  response.data ?? ''
);

/**
 * Link para o guia em PDF do Estudos Upload, na tela Sobre. Aponta para o slug
 * (nao para o id da aba, que varia entre ambientes) e e o mesmo no desktop e
 * no mobile.
 */
export const UPLOAD_GUIDE_TAB_URL = '/flux/about?tab=estudos-upload';

export const slugifyTabTitle = (title: string) => title
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

/**
 * Resolve o parametro `?tab=` da tela Sobre, que aceita tanto o id da aba
 * quanto o slug do titulo (ex.: `estudos-upload`). O slug evita que links
 * externos dependam do id no banco, que varia entre ambientes.
 */
export const resolveAboutTabKey = (
  tabs: InstructionTab[] | undefined,
  requestedTab: string | null,
): string | null => {
  if (!requestedTab || !tabs?.length) return null;

  const requestedSlug = slugifyTabTitle(requestedTab);
  const tab = tabs.find(({ id, title }) => (
    String(id) === requestedTab || slugifyTabTitle(title) === requestedSlug
  ));

  return tab ? String(tab.id) : null;
};
